import { Box } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import React from "react";

import WeeklyEACDirectLaborFixedTable from "./WeeklyEACDirectLaborFixedTable";
import WeeklyEACDirectLaborWeeklyTable from "./WeeklyEACDirectLaborWeeklyTable";
import WeeklyEACDirectLaborTotalsTable from "./WeeklyEACDirectLaborTotalsTable";
import WeeklyEACWeekPicker from "./WeeklyEACWeekPicker";
import { getWeekColumns } from "./weeklyEACCalculations";
import { DIRECT_LABOR_FIXED_TOTAL_WIDTH } from "./weeklyEACColumns";

const saveBtnStyle = {
  border: "1px solid #0070D2",
  borderRadius: "20px",
  padding: "4px 20px",
  cursor: "pointer",
  marginRight: "8px",
};

const cancelBtnStyle = {
  border: "1px solid #0070D2",
  borderRadius: "20px",
  padding: "4px 20px",
  cursor: "pointer",
};

const editBtnStyle = {
  border: "1px solid #0070D2",
  borderRadius: "20px",
  padding: "2px 8px",
  cursor: "pointer",
};

const editIconStyle = {
  color: "#0070D2",
  fontSize: "14px",
  float: "left",
  marginTop: "2px",
};

const editTextStyle = {
  color: "#0070D2",
  marginLeft: "4px",
  fontWeight: 600,
  fontSize: "13px",
};

const noDataStyle = {
  textAlign: "center",
  fontWeight: 600,
  background: "#fff",
  padding: "24px 0",
};

export default function WeeklyEACDirectLaborTable({
  employeeDetails,
  allEmployeeDetails,
  hasOdcData,
  type,
  isEdit,
  isEditable = true,
  isSaving,
  onEdit,
  onSave,
  onCancel,
  onHoursChange,
  scrollRef,
  onScroll,
  weekOptions,
  selectedWeekStartDate,
  onWeekSelect,
}) {
  // Week columns and the grand-total row are derived from the full employee set so they stay
  // stable and consistent with the Summary table regardless of the LCAT search filter — only the
  // per-employee rows reflect the search.
  const weekColumns = getWeekColumns(allEmployeeDetails);

  return (
    <Box style={{ marginTop: "16px" }}>
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Box display="flex" flexDirection="row" alignItems="center">
          <div
            style={{
              width: "220px",
              height: "36px",
              padding: "0 0 0 12px",
              fontSize: "15px",
              color: "#ffffff",
              backgroundColor: "#000",
              borderRadius: "0 10px 0 0",
              display: "flex",
              alignItems: "center",
            }}
          >
            Direct Labor
          </div>
          <WeeklyEACWeekPicker
            weekOptions={weekOptions}
            selectedWeekStartDate={selectedWeekStartDate}
            onWeekSelect={onWeekSelect}
          />
        </Box>
        <Box>
          {(employeeDetails.length > 0 || hasOdcData) &&
            (isEdit ? (
              <>
                <span
                  style={{ ...saveBtnStyle, opacity: isSaving ? 0.5 : 1 }}
                  onClick={isSaving ? undefined : onSave}
                >
                  <span style={editTextStyle}>
                    {isSaving ? "Saving..." : "Save"}
                  </span>
                </span>
                <span
                  style={{ ...cancelBtnStyle, opacity: isSaving ? 0.5 : 1 }}
                  onClick={isSaving ? undefined : onCancel}
                >
                  <span style={editTextStyle}>Cancel</span>
                </span>
              </>
            ) : (
              // GET .../rvn-clins's isEditable=false hides the Edit trigger —
              // regular Download stays available regardless (see
              // WeeklyEACTemplateActions.js for the Template Download/Upload
              // icons, gated the same way).
              isEditable && (
                <div style={editBtnStyle} onClick={onEdit}>
                  <EditIcon style={editIconStyle} />
                  <span style={editTextStyle}> Edit </span>
                </div>
              )
            ))}
        </Box>
      </Box>
      {employeeDetails.length === 0 ? (
        <div style={noDataStyle}>No Data</div>
      ) : (
        <Box display="flex" flexDirection="row">
          <Box
            style={{
              boxShadow: "0px 3px 6px #00000029",
              width: DIRECT_LABOR_FIXED_TOTAL_WIDTH,
              marginRight: "8px",
            }}
          >
            <WeeklyEACDirectLaborFixedTable employeeDetails={employeeDetails} />
          </Box>
          <Box
            ref={scrollRef}
            onScroll={onScroll}
            style={{ overflowX: "auto", boxShadow: "0px 3px 6px #00000029" }}
          >
            <Box display="flex" flexDirection="row">
              <Box style={{ marginRight: "8px" }}>
                <WeeklyEACDirectLaborWeeklyTable
                  employeeDetails={employeeDetails}
                  allEmployeeDetails={allEmployeeDetails}
                  weekColumns={weekColumns}
                  type={type}
                  isEdit={isEdit}
                  onHoursChange={onHoursChange}
                />
              </Box>
              <Box>
                <WeeklyEACDirectLaborTotalsTable
                  employeeDetails={employeeDetails}
                  allEmployeeDetails={allEmployeeDetails}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
}
